export default {
    requiredPlugins: ['queue'],

    install(Vue) {
        Vue.component('notifications', require('../components/Notify').default);

        Vue.$notify = Vue.prototype.$notify = {
            push(type = null, data = {}) {
                if (type instanceof Object) {
                    data = type;
                    type = null;
                }
                if (typeof data !== "object") {
                    data = {body: data};
                }
                if (type !== null) {
                    data.type = type;
                }
                return Vue.$queue.push('notify', data);
            },
            danger: (data = {}) => Vue.$notify.push('danger', data),
            warning: (data = {}) => Vue.$notify.push('warning', data),
            success: (data = {}) => Vue.$notify.push('success', data),
            info: (data = {}) => Vue.$notify.push('info', data),
        };
    },
};